"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _alloyReactFormField = _interopRequireDefault(require("@adsk/alloy-react-form-field"));
var _alloyReactRadioButton = require("@adsk/alloy-react-radio-button");
var _i18n = require("../../../i18n");
var _RadioButton = _interopRequireDefault(require("./RadioButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TypeSelection = _ref => {
  let {
    value,
    options = [],
    onChange
  } = _ref;
  const {
    T
  } = (0, _i18n.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_alloyReactFormField.default, {
    label: T.translate('form.label.type'),
    labelVariant: _alloyReactFormField.default.LABEL_VARIANTS.TOP
  }, /*#__PURE__*/_react.default.createElement(_alloyReactRadioButton.RadioGroup, {
    onChange: onChange,
    value: value
  }, options.map((_ref2, index) => {
    let {
      type,
      title,
      disabled,
      info
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
      key: index,
      value: type,
      disabled: options.length === 1 || disabled,
      label: title,
      info: info
    });
  })));
};
TypeSelection.propTypes = {
  value: _propTypes.default.string,
  options: _propTypes.default.array,
  onChange: _propTypes.default.func.isRequired
};
var _default = exports.default = TypeSelection;